let videoConfig = {
    id: 'J_prismPlayer',
    width: '100%',
    height: '500px',
    skinLayout: [
        {name: "bigPlayButton", align: "cc"},
        {
            name: "H5Loading", align: "cc"
        },
        {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
        {name: "infoDisplay"},
        {name: "tooltip", align: "blabs", x: 0, y: 56},
        {name: "thumbnail"},
        {
            name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
                {name: "progress", align: "blabs", x: 0, y: 44},
                {name: "playButton", align: "tl", x: 15, y: 12},
                {name: "timeDisplay", align: "tl", x: 10, y: 7},
                {name: "fullScreenButton", align: "tr", x: 10, y: 12},
                {name: "setting", align: "tr", x: 15, y: 12},
                {name: "volume", align: "tr", x: 5, y: 10}
            ]
        }
    ],
    mediaType: 'video',
    encryptType: 1,
    autoplay: false,
    isLive: false,
    rePlay: false,
    playsinline: true,
    preload: true,
    controlBarVisibility: 'hover',
    useH5Prism: true,
};
export default class EPlayer {
    constructor(id, config) {
        this.parms = videoConfig;
        this.parms.id = id;
        for (let i in config){
            this.parms[i] = config[i];
        }
        this.player = null;        //播放器实例
        this.videoQasArr = null;   //弹题数组
        this.time = null;          //弹题定时器
        this.time1 = null;         //定时任务
        this.seek = config.seek || 0;
    }
    setSource(source){
        this.parms.source = JSON.stringify(source);
    }
    setProgressMark(marks){
        this.parms.progressMarkers = marks;
    }
    getDuration(){
        return this.player.getDuration();
    }
    getCurrentTime(){
        return this.player.getCurrentTime();
    }
    disableSeek(time){
        this.player.disableSeekTime = time;
        // let that = this;
        // let start = false;
        // let progress = '';
        // this.player.on('startSeek',(e)=> {
        //     if(start){
        //         start = false;
        //         progress =  that.player.getCurrentTime();
        //     }
        //     that.player.pause();
        // });
        // this.player.on('completeSeek', (e) => {
        //     start = true;
        //     time = time||that.player.getDuration();
        //     if(time >= progress){
        //         that.player.seek(progress);
        //     }
        //     that.player.play();
        // });
    }
    seek(time){
        this.player.seek(time);
    }
    play(){
        this.player.play();
    }
    pause(){
        this.player.pause();
    }
    ended(config){
        this.player.on('ended', (e) => {
            console.log(config);
            // this.http.post(this.apis.study.updateMongoVideoTime, config).then(res => {
            // }).catch(err => {
            // })
        });
    }
    /**
     *设置弹题列表  (待实现)
     */
    setQuestionList(videoQasArr, popup, updateMongoVideoTime){
        // console.log(videoQasArr);
        this.videoQasArr = videoQasArr || [];
        
        this.player.on('play', (e) => {
            if (this.videoQasArr.length > 0){
                this.time = setInterval(() => {
                    // console.log(videoQasArr[0].qaTime);
                    // console.log(this.player.getCurrentTime());
                    if (parseFloat(this.player.getCurrentTime()) >= parseFloat(videoQasArr[0].qaTime)){
                        this.player.pause();
                        let len = 0;
                        let thisTime = parseFloat(this.player.getCurrentTime());
                        for (let i in videoQasArr){
                            if (thisTime >= parseFloat(videoQasArr[i].qaTime)){
                                len++;
                            }
                        }
                        popup(videoQasArr.splice(0,len), true);
                    }
                }, 0);
                this.time1 = setInterval(() => {
                    updateMongoVideoTime();
                }, 500);
            }
        });
        this.player.on('pause', (e) => {
            clearInterval(this.time);
            clearInterval(this.time1);
        });
    }

    getCurrentTimePlaying(fun){
        console.log(fun);
        this.player.on('timeupdate', (e) => {
            fun(this.getCurrentTime());
        });
    }

    initVideo(fun) {
        let that = this;
        this.player = new Aliplayer(this.parms, function (player) {
            console.log('播放器创建好了。');
            if (that.parms.vid){
                that.player.seek(that.seek);
                that.player.play();
            } else {
                that.player.setCover('http://file.gzedu.com/upload/downloadFile.do?uploadInfoId=3123f9e6eea74e38803a905441e9e88f');
            }
        });
    }
}
